import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import {ButtonGroup, DialogContent, MenuItem, Snackbar, Stack, TextField, Tooltip} from '@mui/material';
import VeryEditor2 from '../../common/EditorVery/VeryEditor2';
import Service from '../../../util/Service';
import {Grade, Save, Settings} from '@mui/icons-material';
import RulesPopover from '../../page/portal/user/RulesPopover';
import PublicoAlvoDialog from './PublicoAlvoDialog';

import DateCalendarDialog from './DateCalendarDialog';
import dayjs from 'dayjs';
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

const html = '<div>Indique conteudo</div>';
export default function EventoFormDialog(props) {
    const {open, setOpen, action, closeMenu, eventoRoot} = props;

    const [evento, setEvento] = React.useState(eventoRoot);
    // const [open, setOpen] = React.useState(false);
    const [openSnack, setOpenSnack] = React.useState(false);
    const [openDtInicio, setOpenDtInicio] = React.useState(false);
    const [openDtFim, setOpenDtFim] = React.useState(false);
    const [isPrincipal, setIsPrincipal] = React.useState(false);

    const [openEditor, setOpenEditor] = React.useState(false);

    const [dt, setDt] = React.useState();
    const [dt2, setDt2] = React.useState();
    const [nome, setNome] = React.useState('');
    const [nomeCurto, setNomeCurto] = React.useState('');

    // const [html, setHtml] = React.useState('<div>Indique conteudo</div>');

    const [regra, setRegra] = React.useState();
    const [publico, setPublico] = React.useState();
    const ref = React.useRef();

    // React.useEffect(() => {
    //   if (open) {
    //     console.log( 'eventoRoot', eventoRoot);
    //     if(!eventoRoot){
    //        setEvento({ pagina: '<div/>' });
    //        setNome('');
    //        setNomeCurto('');
    //        setPublico();
    //        setRegra();
    //        setDt();
    //        console.log(">>>>NOVO3<<<<<");
    //     }
    //   }
    // }, [open]);

    React.useEffect(() => {
        if (eventoRoot) {
            buscaEvento()
        } else {
            setEvento({pagina: '<div/>'});
            // setHtml("<div>????</div>")
            setNome('');
            setNomeCurto('');
            setPublico();
        }
    }, [eventoRoot])

    function buscaEvento() {
        Service.GET("/api/security/evento/" + eventoRoot.id).then(r => {
            setEvento(r);
            setNome(r.nome);
            setNomeCurto(r.nomeCurto);
            setDt(new Date(r.dtInicial));

            // if (r.dtFinal) {
            //   console.log('>>>>')
            //   setDt2(new Date(r.dtFinal));
            // } else {
            //   setDt2();
            // }
            // setHtml(r.pagina);
            // setRegra(r.regra?r.regra:'');
            setPublico(r.publicoAlvo ? r.publicoAlvo : '');
        })
    }

    const handleClose = () => {
        setOpen(false);
        setEvento();
        if (action) action();
    };

    function montaDado() {
        let currentHtml = '';
        if (ref.current) {
            currentHtml = ref.current.getHtml();
        } else {
            currentHtml = evento && evento.pagina ? evento.pagina : html;
        }

        if (!dt) {
            alert('A data de inicio é obrigatório!')
            return null;
        }

        let dado = {
            nome: nome,
            nomeCurto: nomeCurto,
            regra: regra,
            pagina: currentHtml,
            // dtInicial: dt ? dt.toDate() : null,
            // dtFinal: dt2 ? dt2.toDate() : null,
            publicoAlvo: publico,
        }
        if (!(dt instanceof dayjs)) {
            dado.dtInicial = dt ? dt : null;
            dado.dtFinal = dt2 ? dt2 : null;
        } else {
            dado.dtInicial = dt ? dt.toDate() : null;
            dado.dtFinal = dt2 ? dt2.toDate() : null;
        }
        dado.isPrincipal = isPrincipal;
        if (evento) {
            dado.id = evento.id;
        }
        return dado;
    }

    function handleSalva() {
        let dado = montaDado();
        if (!dado) return;

        Service.POST("/api/security/evento", dado).then(r => {
            if (r.success) {
                setEvento(r.dado);
                setOpenSnack(true);
            } else {
                alert(r.msg);
            }
        })
    }

    function handleSalvaHtml() {

        if (!evento || !evento.id) {
            handleSalva();
            return;
        }
        const currentHtml = ref.current ? ref.current.getHtml() : (evento.pagina || html);
        
        const dado = {
            id: evento.id,
            pagina: currentHtml,
        }

        Service.POST("/api/security/eventoHtml", dado).then(r => {
            if (r.success) {
                setOpenSnack(true);
                setEvento(r.dado);
            } else {
                alert(r.msg);
            }
        });
    }

    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }

    function montaTitulo() {
        let txt = "";//nomeCurto?nomeCurto:""
        if (dt && dt2) {
            txt += " de " + formataData(dt) + ' ate ' + formataData(dt2);
        } else if (dt) {
            txt += formataData(dt);
        }
        return txt;
    }

    function handleEventoPrincipal() {

        setIsPrincipal(!isPrincipal);
    }

    return (
        <React.Fragment>
            <Dialog
                maxWidth="md"
                fullWidth
                open={open}
                onKeyDown={(e) => {
                    e.stopPropagation();
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" component={"span"}>Novo Evento {montaTitulo()}</Typography>
                    <IconButton onClick={handleClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Stack spacing={3} sx={{ mt: 1 }}>

                        <Stack direction="row" spacing={2} alignItems="center">
                            <TextField
                                fullWidth
                                size='small'
                                label="Nome do Evento"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                            />
                            <TextField
                                size='small'
                                label="Nome Curto"
                                value={nomeCurto}
                                sx={{ width: 200 }}
                                onChange={(e) => setNomeCurto(e.target.value)}
                            />
                            <Tooltip title="Marcar como evento principal do dia">
                                <IconButton
                                    color={isPrincipal ? "primary" : "default"}
                                    onClick={handleEventoPrincipal}
                                >
                                    <Grade />
                                </IconButton>
                            </Tooltip>
                        </Stack>

                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="outlined"
                                color={!dt ? "error" : "primary"}
                                onClick={() => setOpenDtInicio(true)}
                                sx={{ flex: 1, justifyContent: 'flex-start' }}
                            >
                                Início: {dt ? formataData(dt) : 'Definir Data/Hora'}
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={() => setOpenDtFim(true)}
                                sx={{ flex: 1, justifyContent: 'flex-start' }}
                            >
                                Fim: {dt2 ? formataData(dt2) : 'Definir Data/Hora'}
                            </Button>
                        </Stack>

                        <Stack direction="row" spacing={2} alignItems="center">
                            <PublicoAlvoDialog publico={publico} setPublico={setPublico} />
                            <RulesPopover action={(r) => setRegra(r.nome)} showTxt={true} regra={regra} />
                        </Stack>

                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<Settings />}
                            onClick={() => setOpenEditor(true)}
                            sx={{ borderStyle: 'dashed' }}
                        >
                            Construir Página HTML do Evento
                        </Button>

                    </Stack>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={handleClose} color="inherit">Cancelar</Button>
                    <Button variant="contained" onClick={handleSalva} disableElevation>
                        Salvar Evento
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog fullScreen open={openEditor} onClose={() => setOpenEditor(false)}>
                <AppBar sx={{ position: 'relative', bgcolor: '#333' }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={() => setOpenEditor(false)}>
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Editor de Conteúdo HTML - {nome || 'Novo Evento'}
                        </Typography>
                        <Button color="inherit" onClick={() => { handleSalvaHtml(); setOpenEditor(false); }}>
                            Salvar HTML
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent sx={{ p: 0 }}>
                    <VeryEditor2
                        html={evento ? evento.pagina : html}
                        ref={ref}
                        style={{ padding: 16, height: 'calc(100vh - 64px)', overflow: 'auto' }}
                    />
                </DialogContent>
            </Dialog>

            <DateCalendarDialog dt={dt} open={openDtInicio} setOpen={setOpenDtInicio} action={setDt} />
            <DateCalendarDialog dt={dt2} open={openDtFim} setOpen={setOpenDtFim} action={setDt2} />
            <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={() => setOpenSnack(false)}
                message="Salvo com sucesso"
            />
        </React.Fragment>
    );
}
